import { IconProps } from "./types";

export const IconlyDelivery3 = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.31069 4.76654L3.46416 6.88287C3.16738 7.62529 3.01365 8.4183 3.01267 9.21715L3.00002 16.9138C2.99419 19.286 4.07132 20.9645 6.44647 20.9703L17.5555 20.9859C19.9297 20.9917 20.9815 19.3201 20.9873 16.9478L21 9.23759C21.0019 8.42511 20.8462 7.61945 20.5427 6.86633L19.6942 4.75973C19.2699 3.70498 18.2463 3.01413 17.1089 3.01413H6.89796C5.75854 3.01413 4.73298 3.7079 4.31069 4.76654Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.61523 16.8647H9.61117"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.13672 8.00684H20.8623"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7081 3.01416L14.5624 8.00661V13.229L11.9946 12.2637L9.4375 13.229V8.00661L10.2918 3.01416"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
